export const CANCELLED_APPOINTMENT_TEXT = "(CANCELLED) ";
export const MASTER_CLINIC_ID = "00000000000000000001";
export const CLIENT_FILE_ID_HASH_SALT = "JourneyCanada";
export const SCA_SUFFIX_TEXT = "-SCA";
